module.exports = function () {    
    if ($('#landing-page-with-search .dropdown-filters--active').length) {
        $('#landing-page-with-search ~ div').addClass('hidden');
    }
    else {
        $('#landing-page-with-search ~ div').removeClass('hidden');
    }
};